import React from 'react';
import _d from '@repperjs/debug';
import { Provider, ReactReduxContext } from 'react-redux';
import { createTheme, CssBaseline, ThemeProvider } from '@mui/material';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AppRoute } from '../state/@types/AppRoute';
import { mobileTheme } from './themes/mobileTheme.ts';
import { appTheme } from './themes/appTheme.ts';

/* eslint-disable no-unused-vars */
const log = _d('repper:components:AppContainer'),
    error = _d('repper:error'),
    warn = _d('repper:warning');
/* eslint-enable no-unused-vars */

// application theme
const appThemeV5 = createTheme(appTheme);
const mobileAppThemeV5 = createTheme(mobileTheme);

function AppContainer({ routes, store }: { routes: AppRoute[]; store: any }) {
    return (
        <Provider context={ReactReduxContext} store={store}>
            <Router>
                <Routes>
                    {routes.map((route) => {
                        const Element = route.component;
                        return (
                            <Route
                                key={route.path}
                                path={route.path}
                                element={
                                    <ThemeProvider theme={route.isMobile ? mobileAppThemeV5 : appThemeV5}>
                                        <CssBaseline />
                                        <Element />
                                    </ThemeProvider>
                                }
                            />
                        );
                    })}
                </Routes>
            </Router>
        </Provider>
    );
}

export default AppContainer;
